export function saveUTMSourceToLocalStorage() {
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get("utm_source") || params.get("utmSource");
  if (utmSource) {
    localStorage.setItem("utmSource", utmSource);
  }
}

export function getUTMSourceFromLocalStorage(): string | null {
  return localStorage.getItem("utmSource");
}
